import { createStyles } from "@mantine/core";

export const useStyles = createStyles((theme) => ({
  linkWrapper: {
    background: theme.colors.midnightBlue[0],
    color: theme.colors.white[0],

    "&:hover": {
      color: theme.colors.golden[0],
      cursor: "pointer",
    },
  },

  nestedLinkWrapper: {
    background: theme.colors.dusk[0],
    color: theme.colors.white[0],

    "&:hover": {
      color: theme.colors.golden[0],
      cursor: "pointer",
    },
  },
}));
